export default "__VITE_ASSET__BTUJFmjo__"